import { Injectable } from '@angular/core';
import { GlobalHeaderConfig } from '@vi/global-header';
import { environment } from '../../../environments/environment';
import { replaceDomainUrl } from './auth.service';

@Injectable({
    providedIn: 'root',
})
export class RuntimeConfigService {
    constructor() {}

    ghConfig: GlobalHeaderConfig;

    init(): void {
        this.ghConfig = {
            ...environment.globalHeader,
            baseUrl: replaceDomainUrl(environment.globalHeader.baseUrl),
            appId: environment.saml.appId,
        };
    }

    getGlobalHeaderConfig(): GlobalHeaderConfig {
        return this.ghConfig;
    }
}
